import { computed } from 'vue';

import { useVersion } from '@abaninja/data-access-version';

const UPDATE_INTERVAL = 30_000;

export const useNewVersionAvailable = () => {
  const { data } = useVersion(UPDATE_INTERVAL);

  const currentVersion = import.meta.env.VITE_SENTRY_RELEASE_VERSION;

  const isNewVersionAvailable = computed(
    () => Boolean(data.value && currentVersion !== data.value.data.version),
  );

  return {
    currentVersion,
    entity: computed(() => data.value?.data),
    isNewVersionAvailable,
  };
};
